import React from 'react';

import { Button, TextClamp } from '@components/common';

import { TAssetProfile } from '@interfaces/assets/asset';

import styles from './Summary.module.scss';

interface ISummaryProps {
	profile?: TAssetProfile;
	toggleAssetModal: () => void;
	isEditAccess: boolean;
}

const Summary = ({ profile, toggleAssetModal, isEditAccess }: ISummaryProps) => {
	const address = [
		profile?.adPropertyNoName,
		profile?.adStreetName,
		profile?.adLocality,
		profile?.adTownCity,
		profile?.adPostCode,
	].filter(item => !!item).join(', ');

	return (
		<div className={styles.summaryContainer}>
			<div className={styles.listContainer}>
				<div>
					<div className={styles.list}>
						{address
							&& <>
								<div>Address</div>
								<div>
									<TextClamp text={address} />
								</div>
							</>
						}
						{!!profile?.ngr
							&& <>
								<div>NGR</div>
								<div>{profile?.ngr}</div>
							</>
						}
						<div>Latitude</div>
						<div>{profile?.lat}</div>
						<div>Longitude</div>
						<div>{profile?.lng}</div>
						{!!profile?.northing
							&& <>
								<div>Northing</div>
								<div>{profile.northing}</div>
							</>
						}
						{!!profile?.easting
							&& <>
								<div>Easting</div>
								<div>{profile.easting}</div>
							</>
						}
						{!!profile?.locationDescription
							&& <>
								<div>
									Location
									<br />
									Description
								</div>
								<div>
									<TextClamp text={profile.locationDescription} />
								</div>
							</>
						}
					</div>
				</div>
				<div>
					<div className={styles.list}>
						{!!profile?.contactPerson
							&& <>
								<div>Contact Person</div>
								<div>{profile.contactPerson.firstName} {profile.contactPerson.lastName}</div>
								<div>Contact Email</div>
								<div>{profile.contactPerson.email}</div>
							</>
						}
						<div>Pricing</div>
						<div>£{profile?.indicativeAcceptablePricing}</div>
						<div>Max Operators</div>
						<div>{profile?.maxOperators}</div>
						{!!profile?.height
							&& <>
								<div>Height</div>
								<div>{profile.height} meters</div>
							</>
						}
						{!!profile?.responsible?.title
							&& <>
								<div>Responsible</div>
								<div>{profile.responsible.title}</div>
							</>
						}
						{!!profile?.uprn
							&& <>
								<div>UPRN</div>
								<div>{profile.uprn}</div>
							</>
						}
						{!!profile?.assetOwnerNotes
							&& <>
								<div>Notes</div>
								<div>
									<TextClamp text={profile.assetOwnerNotes} />
								</div>
							</>
						}
					</div>
				</div>
			</div>
			<div className={styles.summaryButtons}>
				{isEditAccess
					&& <Button
						onClick={toggleAssetModal}
						text='Edit'
					/>
				}
			</div>
		</div>
	);
};

export default Summary;
